import { Injectable } from '@angular/core';
import { ApiService, PageData, ReadonlyRepositoryImpl } from '@eceos/arch';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ElotechSpecialTaxationRegime } from '../special-taxation-regime';

@Injectable({ providedIn: 'root' })
export class ElotechSpecialTaxationRegimeRepository extends ReadonlyRepositoryImpl<
  ElotechSpecialTaxationRegime,
  ElotechSpecialTaxationRegime
> {
  constructor(api: ApiService) {
    super(
      api.root.path('fiscal/settings/nfes/elotechTaxations'),
      ElotechSpecialTaxationRegime,
      ElotechSpecialTaxationRegime
    );
  }

  getFirst(): Observable<ElotechSpecialTaxationRegime> {
    return this.page(new PageData(0, 1)).pipe(map((value) => (value ? value[0] : null)));
  }
}
